// extracted by mini-css-extract-plugin
export default {"formHeading":"VH-z","form":"WH-z","submitBtn":"XH-z","disabled":"YH-z","input":"ZH-z","error":"_H-z","submitMsg":"aI-z","signIn":"bI-z"};